var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tipoMenu == 'planificacion')?_c('div',[_c('agendaAsesorVue')],1):_vm._e(),(_vm.tipoMenu == 'capacitaciones')?_c('div',[_c('capacitacionesAgendaVue1')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }